import _classCallCheck from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _assertThisInitialized from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _getPrototypeOf from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/var/lib/jenkins/workspace/vix.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * DevExtreme (esm/renovation/ui/pager/page_size/selector.js)
 * Version: 22.1.5
 * Build date: Fri Sep 02 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["isLargeDisplayMode", "pageSize", "pageSizeChange", "pageSizes", "rootElementRef"];
import { createVNode, createComponentVNode } from "inferno";
import { InfernoEffect, InfernoComponent } from "@devextreme/runtime/inferno";
import { PageSizeSmall } from "./small";
import { PageSizeLarge } from "./large";
import { InternalPagerProps } from "../common/pager_props";
import messageLocalization from "../../../../localization/message";
import { PAGER_PAGE_SIZES_CLASS } from "../common/consts";
export var viewFunction = function viewFunction(_ref) {
  var htmlRef = _ref.htmlRef,
      normalizedPageSizes = _ref.normalizedPageSizes,
      _ref$props = _ref.props,
      isLargeDisplayMode = _ref$props.isLargeDisplayMode,
      pageSize = _ref$props.pageSize,
      pageSizeChange = _ref$props.pageSizeChange;
  return createVNode(1, "div", PAGER_PAGE_SIZES_CLASS, [isLargeDisplayMode && createComponentVNode(2, PageSizeLarge, {
    pageSizes: normalizedPageSizes,
    pageSize: pageSize,
    pageSizeChange: pageSizeChange
  }), !isLargeDisplayMode && createComponentVNode(2, PageSizeSmall, {
    parentRef: htmlRef,
    pageSizes: normalizedPageSizes,
    pageSize: pageSize,
    pageSizeChange: pageSizeChange
  })], 0, null, null, htmlRef);
};

function getAllText() {
  return messageLocalization.getFormatter("dxPager-pageSizesAllText")();
}

var PageSizeSelectorProps = {
  isLargeDisplayMode: true
};
var PageSizeSelectorPropsType = {
  get pageSize() {
    return InternalPagerProps.pageSize;
  },

  get pageSizes() {
    return InternalPagerProps.pageSizes;
  },

  get isLargeDisplayMode() {
    return PageSizeSelectorProps.isLargeDisplayMode;
  }

};
import { createRef as infernoCreateRef } from "inferno";
export var PageSizeSelector =
/*#__PURE__*/
function (_InfernoComponent) {
  _inherits(PageSizeSelector, _InfernoComponent);

  function PageSizeSelector(props) {
    var _this;

    _classCallCheck(this, PageSizeSelector);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PageSizeSelector).call(this, props));
    _this.state = {};
    _this.htmlRef = infernoCreateRef();
    _this.__getterCache = {};
    _this.setRootElementRef = _this.setRootElementRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(PageSizeSelector, [{
    key: "createEffects",
    value: function createEffects() {
      return [new InfernoEffect(this.setRootElementRef, [])];
    }
  }, {
    key: "setRootElementRef",
    value: function setRootElementRef() {
      var rootElementRef = this.props.rootElementRef;

      if (rootElementRef) {
        rootElementRef.current = this.htmlRef.current;
      }
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps, nextState, context) {
      _get(_getPrototypeOf(PageSizeSelector.prototype), "componentWillUpdate", this).call(this);

      if (this.props.pageSizes !== nextProps.pageSizes) {
        this.__getterCache.normalizedPageSizes = void 0;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      return viewFunction({
        props: _extends({}, props),
        htmlRef: this.htmlRef,
        normalizedPageSizes: this.normalizedPageSizes,
        restAttributes: this.restAttributes
      });
    }
  }, {
    key: "normalizedPageSizes",
    get: function get() {
      var _this2 = this;

      if (void 0 !== this.__getterCache.normalizedPageSizes) {
        return this.__getterCache.normalizedPageSizes;
      }

      return this.__getterCache.normalizedPageSizes = function () {
        var pageSizes = _this2.props.pageSizes;
        return pageSizes.map(function (p) {
          return "all" === p || 0 === p ? {
            text: getAllText(),
            value: 0
          } : {
            text: String(p),
            value: p
          };
        });
      }();
    }
  }, {
    key: "restAttributes",
    get: function get() {
      var _this$props = this.props,
          restProps = _objectWithoutPropertiesLoose(_this$props, _excluded);

      return restProps;
    }
  }]);

  return PageSizeSelector;
}(InfernoComponent);
PageSizeSelector.defaultProps = PageSizeSelectorPropsType;